import { WEEK } from '../constants';
import getCurrentTime from './getCurrentTime';
import { get, set } from './tempStorage';
const isTranslationArray = val => {
  return typeof val === 'object' && val !== null && Array.isArray(val);
};
export const isKnownAndNotExpiredMissingTranslation = (translationKey, localStorageKey) => {
  const knownMissingTranslationsInLS = get(localStorageKey);
  if (knownMissingTranslationsInLS) {
    try {
      const knownMissingTranslations = JSON.parse(knownMissingTranslationsInLS);
      if (isTranslationArray(knownMissingTranslations)) {
        for (const missingTranslation of knownMissingTranslations) {
          const {
            key,
            date
          } = missingTranslation;
          if (key === translationKey && getCurrentTime() - parseInt(date, 10) < WEEK) {
            return true;
          }
        }
        return false;
      }
    } catch (_unused) {
      // no-op
    }
  }
  return false;
};
export const logKnownMissingTranslation = (translationKey, localStorageKey) => {
  if (!translationKey) {
    return;
  }
  const knownMissingTranslationsInLS = get(localStorageKey);
  if (knownMissingTranslationsInLS) {
    try {
      const knownMissingTranslations = JSON.parse(knownMissingTranslationsInLS);
      if (isTranslationArray(knownMissingTranslations)) {
        const missingTranslations = knownMissingTranslations.reduce((result, currentTranslationLog) => {
          if (currentTranslationLog.key === translationKey || getCurrentTime() - parseInt(currentTranslationLog.date, 10) >= WEEK) {
            return result;
          }
          result.push(currentTranslationLog);
          return result;
        }, []);
        missingTranslations.push({
          key: translationKey,
          date: getCurrentTime().toString()
        });
        set(localStorageKey, JSON.stringify(missingTranslations));
        return;
      }
    } catch (_unused2) {
      // no-op
    }
  }
  set(localStorageKey, JSON.stringify([{
    key: translationKey,
    date: getCurrentTime().toString()
  }]));
};